import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
type RuleType = (value: string) => boolean | string
type ValidateType = { [key: string]: RuleType }

export type UseValidationProps = {
  maxLength?: number
  required?: boolean
  rules?: RuleType[]
}
export const useValidation = (props: UseValidationProps) => {
  const { rules = [] } = props

  const { t } = useTranslation()
  const {
    register,
    formState: { isValid, errors },
    setValue,
  } = useForm({ defaultValues: { value: '' }, mode: 'all' })

  const helperText = useMemo(() => errors?.value?.message || '', [errors?.value?.message])
  const maxLength = useMemo(
    () =>
      props?.maxLength
        ? { value: props.maxLength, message: t('validate.maxLength', { length: props.maxLength }) }
        : undefined,
    [props?.maxLength, t]
  )
  const required = useMemo(
    () => (props?.required ? { value: props.required, message: t('validate.required') } : undefined),
    [props?.required, t]
  )
  const validate = useMemo(
    () => rules.reduce<ValidateType>((acc, cur, index) => Object.assign(acc, { [`${index}`]: cur }), {}),
    [rules]
  )

  return { register, setValue, helperText, maxLength, required, validate, error: !!errors?.value, isValid }
}
